import React from 'react';

import { Box, CircularProgress } from '@mui/material';

import useStyles from './styles';

const Spinner = () => {
    const { classes } = useStyles();
    return (
        <Box className={classes.container}>
            <CircularProgress />
        </Box>
    );
};

export default Spinner;
